<div *ngIf="isSlice || getTotalPages() > 1" class="pagination-container">
  <div class="pagination-btns ms-2 p-3">
    <ng-container>
      <button
        (click)="previousPage()"
        [disabled]="page === 1"
        class="previous-btn">
        {{ 'Previous' | translate }}
      </button>
      <button
        (click)="nextPage()"
        [disabled]="isSlice ? isLastPage : page === getTotalPages()"
        class="next-btn">
        {{ 'Next' | translate }}
      </button>
    </ng-container>
  </div>
  <div class="pagination-page-info me-3 p-3">
    {{ 'Page' | translate }} {{ page }}
    <ng-container *ngIf="!isSlice">of {{ getTotalPages() }}</ng-container>
  </div>
</div>
